var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Toast"}},[(_vm.show)?_c('div',[_c('div',{staticClass:"note",domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }